import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import PN from "persian-number";
import Drp_Brand from '../ProductBrand/Drp_Brand';
import Drp_Group from '../ProductGroup/Drp_Group';
import Drp_ParentGroup from '../ProductGroup/Drp_Group';


const ProductPricePercentIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const SearchBrandRef = useRef();
    const SearchGroupRef = useRef();
    const SearchParentGroupRef = useRef();


    const [ProductList, setProductList] = useState([]);
    const [SearchTitle, setSearchTitle] = useState('');
    const [SearchGroupId, setSearchGroupId] = useState(-1);
    const [SearchParentGroupId, setSearchParentGroupId] = useState(-1);
    const [SearchBrandId, setSearchBrantId] = useState(-1);
    const [SearchIsActive, setSearchIsActive] = useState(1);
    const [SearchWebIsActive, setSearchWebIsActive] = useState(1);
    const [Percent, setPercent] = useState(0);


    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion




    const SearchParent_Change = (value) => {
        setSearchParentGroupId(value);
        SearchGroupRef.current.BindGroupByParentId(0, value)
    }

    const Percent_Change = (value) => {
        var temp = [...ProductList];
        temp.forEach(element => {
            element.FinalPrice = (value / 100 * element.LastPrice).toFixed() * 1 + element.LastPrice * 1;
            element.FinalPriceCoworker = (value / 100 * element.LastPriceCoworker).toFixed() * 1 + element.LastPriceCoworker * 1;
            element.Percent = value;
        });
        setPercent(value)
        setProductList(temp);
    }

    //#region Methods

    const Search = () => {
        if (SearchBrandId == -1 && SearchParentGroupId == -1 && SearchTitle == "" && SearchGroupId == -1)
            toaster.push(General.ShowMessage('error', General.ErrorMessage("  انتخاب یکی از فیلترهای جسنجو اجباری می باشد")), 'topCenter')
        else {
            trackPromise(
                fetch(General.ApiRoute() + '/Product/SearchForUpdatePrice', {
                    method: 'Get',
                    headers: {
                        'ApiKey': General.APIKey(),
                        'BrandId': SearchBrandId,
                        'ProductGroupId': SearchGroupId,
                        'ProductGroupParentId': SearchParentGroupId,
                        'Title': SearchTitle,
                        'WebIsActive': SearchWebIsActive,
                        'IsActive': SearchIsActive
                    },
                    credentials: 'include'
                })
                    .then(res => res.json())
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                Id: result[i].id,
                                LastPrice: result[i].lastPrice,
                                LastPriceCoworker: result[i].lastPriceCoworker,
                                Title: result[i].title + " (شناسه : " + result[i].identityNo + ")",
                                ParentTitle: result[i].parentTitle,
                                GroupTitle: result[i].groupTitle,
                                BrandTitle: result[i].brandTitle,
                                IdentityNo: result[i].identityNo,
                                LastPriceDate: result[i].lastPriceDate,
                                LastPriceTime: result[i].lastPriceTime,
                                Percent: 0,
                                FinalPrice: result[i].lastPrice,
                                FinalPriceCoworker: result[i].lastPriceCoworker,

                            })
                        }
                        setProductList(tmp)
                    })
            )

        }
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };

    const Change_Item = (row, value) => {
        var temp = [...ProductList];
        var index = temp.findIndex(x => x.Row == row);

        if (index != -1) {
            temp[index].FinalPrice = (value / 100 * temp[index].LastPrice).toFixed() * 1 + temp[index].LastPrice * 1;
            temp[index].FinalPriceCoworker = (value / 100 * temp[index].LastPriceCoworker).toFixed() * 1 + temp[index].LastPriceCoworker * 1;
            temp[index].Percent = value;
        }
        setProductList(temp);
    }


    const Save = () => {

        var RequestOptions = {
            data: {
                Id: General.GuidEmpty(),
                "ProductList": ProductList

            },
            url: General.ApiRoute() + "/Product/UpdatePrice",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        Search();
                        setPercent(0)
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }






    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 18);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        SearchBrandRef.current.BindBrand(-1);
                        SearchParentGroupRef.current.BindGroupByParentId(-1, 0);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }




    useEffect(() => {
        CheckPermission();
        document.title = "به روز رسانی قیمت محصولات ";
    }, [])
    //#endregion







    return (

        <Layout title="به روز رسانی قیمت محصولات ">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={Save}>  ثبت</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>عتوان   </label>
                            <rsuite.Input value={SearchTitle} onChange={(e) => setSearchTitle(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ParentGroup className="rs-input" value={SearchParentGroupId} onChange={SearchParent_Change} ref={SearchParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_Group className="rs-input" value={SearchGroupId} onChange={(value) => setSearchGroupId(value)} ref={SearchGroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> برند   </label>
                            <Drp_Brand className="rs-input" value={SearchBrandId} onChange={(value) => setSearchBrantId(value)} ref={SearchBrandRef} />
                        </rsuite.Col>
                        {/* <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> وضعیت فعال بودن   </label>
                            <select className="rs-input" onChange={(e) => setSearchIsActive(e.target.value)} value={SearchIsActive}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال </option>


                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> وضعیت فعال بودن در وب سایت   </label>
                            <select className="rs-input" onChange={(e) => setSearchWebIsActive(e.target.value)} value={SearchWebIsActive}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال </option>


                            </select>
                        </rsuite.Col> */}


                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={520}
                                    data={ProductList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}
                                    headerHeight={60}

                                >
                                    <rsuite.Table.Column fullText className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Title" />
                                    </rsuite.Table.Column>



                                    <rsuite.Table.Column fullText width={100} sortable resizable>
                                        <rsuite.Table.HeaderCell>گروه</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='ParentTitle' />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText width={100} sortable resizable>
                                        <rsuite.Table.HeaderCell>زیر گروه</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='GroupTitle' />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText width={100} sortable resizable>
                                        <rsuite.Table.HeaderCell> برند</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='BrandTitle' />
                                    </rsuite.Table.Column>
                                    {/* <rsuite.Table.Column fullText width={100} sortable resizable>
                                        <rsuite.Table.HeaderCell> تاریخ</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='LastPriceDate' />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText width={100} sortable resizable>
                                        <rsuite.Table.HeaderCell> ساعت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='LastPriceTime' />
                                    </rsuite.Table.Column> */}
                                       <rsuite.Table.Column fullText width={130} sortable resizable>
                                        <rsuite.Table.HeaderCell> زمان به روزرسانی </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >
                                            {(rowData) => {
                                                return <>
                                                    {rowData.LastPriceDate}
                                                    <br/>
                                                    {rowData.LastPriceTime}


                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column  width={100} >
                                        <rsuite.Table.HeaderCell>

                                            <rsuite.Input value={Percent} onChange={value => {
                                                Percent_Change?.(value);
                                            }} placeholder='درصد افزایش قیمت %' />
                                        </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell >
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Input value={rowData.Percent} onChange={value => {
                                                        Change_Item?.(rowData.Row, value);
                                                    }} placeholder='درصد افزایش قیمت %'
                                                    />
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText width={110} sortable resizable>
                                        <rsuite.Table.HeaderCell> قیمت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >
                                            {(rowData) => {
                                                return <>
                                                    {PN.sliceNumber(rowData.LastPrice)}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText width={100} sortable resizable>
                                        <rsuite.Table.HeaderCell className='text-success'> قیمت نهایی</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell className='text-success' >
                                            {(rowData) => {
                                                return <>
                                                    {PN.sliceNumber(rowData.FinalPrice)}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText width={120} sortable resizable>
                                        <rsuite.Table.HeaderCell> قیمت همکار</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >
                                            {(rowData) => {
                                                return <>
                                                    {PN.sliceNumber(rowData.LastPriceCoworker)}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>



                                    <rsuite.Table.Column fullText width={130} sortable resizable>
                                        <rsuite.Table.HeaderCell className='text-success'> قیمت نهایی همکار</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  className='text-success'>
                                            {(rowData) => {
                                                return <>
                                                    {PN.sliceNumber(rowData.FinalPriceCoworker)}
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >


        </Layout >


    )
}

export default ProductPricePercentIndex;